export const CONVERSION_CANCELLED_MESSAGE = 'Создание отменено пользователем.';

let activeCancel: (() => void) | null = null;
let activeToken = 0;

export function registerConversionCancel(cancel: () => void): () => void {
  const token = ++activeToken;
  activeCancel = cancel;
  return () => {
    if (activeToken === token) {
      activeCancel = null;
    }
  };
}

export function cancelActiveConversion(): boolean {
  const cancel = activeCancel;
  if (!cancel) {
    return false;
  }
  activeCancel = null;
  cancel();
  return true;
}

export function isConversionCancelledMessage(message: string): boolean {
  return message.trim().startsWith(CONVERSION_CANCELLED_MESSAGE);
}
